import React, { FC, useEffect, useState, useRef } from 'react';
import {
  PageWrapper,
  GenericList,
  LoadingAnimation,
  Questionnaire,
  AdditionalQuestionnaireListContent,
  QuestionnaireWithResultSets,
  useShowConfirmationPopup,
  useShowAlertPopup,
  FileUpload,
} from '@dew21/ui';
import axios from 'axios';

export const Questionnaires: FC = (props) => {
  const [questionnairesList, setQuestionnairesList] = useState<Questionnaire[] | null>(null);
  const showConfirmationPopup = useShowConfirmationPopup();
  const showNotificationBanner = useShowAlertPopup();
  const uploadRef = useRef<QuestionnaireWithResultSets | null>(null);

  const fetchQuestionnaires = () => {
    return axios.get('/api/questionnaire/all');
  };

  useEffect(() => {
    fetchQuestionnaires().then((response) => {
      setQuestionnairesList(response.data);
    }).catch((error) => {
      console.log(error);
    });
  }, []);

  return (
    <PageWrapper
      breadCrumb={[{ title: 'Fragebögen', path: '/questionnaires' }]}
      marginal={{
        items: [
          {
            text: 'Neuen Fragebogen hinzufügen',
            icon: 'add-user',
            actionFn: () => {
              showConfirmationPopup({
                open: true,
                renderer: () => {
                  return <FileUpload
                    id={'add-questionnaire'}
                    allowedFileTypes={['application/json', 'text/json']}
                    multiFileUpload={false}
                    label={'Fragebogen definition'}
                    onChange={(files) => {
                      if (files[0]) {
                        const baseFile = files[0].dataUrl.replace('data:application/json;base64,', '') || '';

                        const b64DecodeUtf8 = (str: string) => {
                          return decodeURIComponent(atob(str).split('').map((c) => {
                            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                          }).join(''));
                        };

                        const json = JSON.parse(b64DecodeUtf8(baseFile)) || null;
                        if (json) {
                          uploadRef.current = json;
                        }
                      }
                    }} />;
                },
                closeFn: () => {
                  uploadRef.current = null;
                  showConfirmationPopup(null);
                },
                actionFn: () => {
                  if (uploadRef.current) {
                    const data = uploadRef.current;
                    axios.post('/api/questionnaire/create', { ...data }).then((response) => {
                      setQuestionnairesList(response.data);
                      showNotificationBanner({ renderContent: () => <>Der Fragebogen wurde erfolgreich angelegt.</> });
                    }).catch((e) => {
                      showNotificationBanner({
                        error: true,
                        renderContent: () => <>Bitte sorgen Sie dafür das die hochgeladene Datei im richtigen Format
                          ist.</>,
                      });
                    });
                  } else {
                    showNotificationBanner({
                      error: true,
                      renderContent: () => <>Es ist ein unerwarteter Fehler aufgetreten, bitte versuchen Sie es in 15
                        Minuten erneut.</>,
                    });
                  }
                  uploadRef.current = null;
                  showConfirmationPopup(null);
                },
                actionButtonLabel: 'Speichern',
              });
            },
          }],
      }}>
      {
        questionnairesList && questionnairesList.length > 0 ? (
          <GenericList
            displayColumnNames={true}
            collapsible={true}
            additionalRenderFn={(item: QuestionnaireWithResultSets) => (
              <AdditionalQuestionnaireListContent item={item} />
            )}
            columns={[
              { name: 'description', displayName: 'Fragebogen', sortable: false },
            ]}
            items={questionnairesList}
            countLabel={`${questionnairesList.length} Fragebögen gefunden`}
          />
        ) : <LoadingAnimation overlay transparent />
      }
    </PageWrapper>
  );
};
